import React, { useEffect, useState } from "react";
import "./App.css";
import { LicenseInfo } from "@mui/x-license-pro";
import { Route, Routes, Navigate } from "react-router-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { USAppraisalDashboardList } from "./components/appraisal/us/USAppraisalDashboardList";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { Navbar } from "./layout/Navbar";
import { GlobalAppraisalDashboardList } from "./components/appraisal/global/GlobalAppraisalDashboardList";
import { GlobalAppraisalForm } from "./components/appraisal/global/GlobalAppraisalForm";
import { AppraisalFormNew } from "./components/appraisal/us/AppraisalFormNew";
import { DebtLiabilityAppraisalFormNew } from "./components/appraisal/us/DebtLiabilityAppraisalFormNew";
import UserRoleMapDashboard from "./components/settings/user-role-map/UserRoleMapDashboard";
import { Firm } from "./components/settings/appraiser-firm-master/AppraiserFirmViewEditForm";
import { UserRoleMapFormNew } from "./components/settings/user-role-map/UserRoleMapFormNew";
import { AppraiserFirmDashboard } from "./components/settings/appraiser-firm-master/AppraiserFirmDashboard"
import { FundConfigurationDashboard } from "./components/settings/fund-configuration/FundConfigurationDashboard";
import { FundConfigurationNewForm } from "./components/settings/fund-configuration/FundConfigurationNewForm";
import { FundConfigurationDisplayEditForm } from "./components/settings/fund-configuration/FundConfigurationDisplayEditForm";
import { AppraiserFirmNewForm } from "./components/settings/appraiser-firm-master/AppraiserFirmNewForm";
import InvestmentsDashboard from "./components/settings/investment-master/InvestmentsDashboard";
import FundsDashboard from "./components/settings/fund/FundsDashboard";
import { FundNewForm } from "./components/settings/fund/FundNewForm";
import { FundDisplayEditForm } from "./components/settings/fund/FundDisplayEditForm";
import RoleDashboard from "./components/settings/role/RoleDashboard";
import { RoleEditDisplayForm } from "./components/settings/role/RoleEditDisplayForm";
import { InvetmentsFormNew } from "./components/settings/investment-master/InvestmentsFormNew";

import useConfig from "./hooks/common-hooks";

import {
  Configuration,
  InteractionType,
  PublicClientApplication,
} from "@azure/msal-browser";
import {
  MsalAuthenticationTemplate,
  MsalProvider,
  useMsal,
} from "@azure/msal-react";
import {
  CurrentUser,
  updateCurrentUser,
} from "./redux/slices/currentUserSlice";
import { useAppDispatch } from "./redux/hooks";
import { SessionTimeoutPopup } from "./notification/sessionTimeoutPopup";
//import { BreadcrumbBar } from "./layout/Breadcrumbs";
import Container from "@mui/material/Container";
import { getUserContextFromAzure, postApiCall } from "./services/apiHelper";
import { AppraisalReviewServiceURL, GraphAPIURL } from "./config/config";
import { getProfile } from "./services/userContext";

import {
  UserContext,
  updateUserContext,
} from "./redux/slices/userContextSlice";
import { GlobalAppraisalEditDisplayForm } from "./components/appraisal/global/GlobalAppraisalEditDisplayForm";
import { UserRoleMapEditDisplayForm } from "./components/settings/user-role-map/UserRoleMapEditDisplayForm";
import { AppraisalFormEdit } from "./components/appraisal/us/AppraisalFormEdit";
import { Unauthorized } from "./layout/Unauthorized";
import UserContextHook from "./hooks/userContext-hook";
import { DebtLiabilityAppraisalFormEdit } from "./components/appraisal/us/DebtLiabilityAppraisalFormEdit";
import { AppraisalFormView } from "./components/appraisal/us/AppraisalFormView";
import { DebtLiabilityAppraisalFormView } from "./components/appraisal/us/DebtLiabilityAppraisalFormView";
import { InvestmentEditDisplayForm } from "./components/settings/investment-master/InvestmentEditDisplayForm";
import { BreadcrumbBar } from "./layout/Breadcrumbs";
import TodoDashboard from "./components/settings/todo-list/TodoDashboard";
import { updateTodoListCount } from "./redux/slices/TodoListCountSlice";
import RootComponent from "RootComponent";

// LicenseInfo.setLicenseKey(
//   "367972f0bde4644194a38aa8668f4c0eTz04ODE1OCxFPTE4MDg0MDk2MDAwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI="
// );

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENCE_KEY as string);

//Licensing Material UI

console.log("Inside App.tsx ");
const AuthProvider = (props: any) => {
  console.log("Inside App.tsx before useConfig");
  const [config] = useConfig();
  console.log("Inside App.tsx after useConfig");

  if (!config?.msalConfig?.auth) return <>Loading config...</>;

  // MSAL configuration
  const configuration: Configuration = { ...config.msalConfig };

  const pca = new PublicClientApplication(configuration);

  console.log("Inside App.tsx before returning pca instance" , configuration , " >>>> " , pca);
  return <MsalProvider instance={pca}>{props.children}</MsalProvider>;
};
export const Main = () => {
  const config = {};
  const [userLoadComplete, setUserLoadComplete] = useState(false);
  const { accounts, instance } = useMsal();
  const dispatch = useAppDispatch();
  // console.log(instance);
  const userContext = UserContextHook();
  console.log(userContext);
  if (!userContext?.email) return <>Loading User...</>;

  dispatch(updateUserContext(userContext as UserContext));

  if (accounts && accounts.length > 0) {
    const account = accounts[0];
    instance.setActiveAccount(account);

    const currentUser: CurrentUser = {
      name: account?.name,
      email: account?.username,
      tenantId: account?.tenantId,
    };

    console.log(currentUser);
    dispatch(updateCurrentUser(currentUser));

    // var url = AppraisalReviewServiceURL + "/appraisals/GetTodoList?emailAddress";
    // var payload = {
    //   filters: [],
    //   first: 0,
    //   filterConditionalOperator: "and",
    //   globalFilter: null,
    //   rows: "100",
    //   sortOrder: 1,
    //   emailId : "Ser_NRETest4@qicaait.org" //currentUserData.email?.toLowerCase(),
    // };
    // const response = postApiCall(url, payload, "AppraisalReviewService").then(
    //   (data: any) => dispatch(updateTodoListCount(data?.result?.rowCount)));
  }

  return (
    <div className="App">
      <Header />
      <SessionTimeoutPopup />
      <Router>
        <Navbar />
        <Container maxWidth={false}>
          <BreadcrumbBar />
          <Routes>
            {/* {(userContext.isEMEA && userContext.isUS) ?
              <Route path="/" element={<GlobalAppraisalDashboardList />} />
              :
              <Route path="/" element={<USAppraisalDashboardList />} />} */}
              {userContext.isEMEA || userContext.isAPAC && <Route path="/" element={<GlobalAppraisalDashboardList />} />}
              {userContext.isUS && <Route path="/" element={<USAppraisalDashboardList />} />}
            {/* <Route path="/" element={<USAppraisalDashboardList />} /> */}
            <Route
              path="/global/dashboard"
              element={<GlobalAppraisalDashboardList />}
            />
            <Route
              path="/main/dashboard"
              element={<USAppraisalDashboardList />}
            />
            <Route
              path={"/global/global-equity/new"}
              Component={GlobalAppraisalForm}
            />
            <Route
              path={"/main/appraisal-form/:page"}
              Component={AppraisalFormNew}
            />
            <Route
              path={"/main/appraisal-form/edit/:appraisalId"}
              Component={AppraisalFormEdit}
            />
            <Route
              path={"/main/appraisal-form/view/:appraisalId"}
              Component={AppraisalFormView}
            />
            <Route
              path={"/main/debt-liability/:page"}
              Component={DebtLiabilityAppraisalFormNew}
            />
            <Route
              path={"/main/debt-liability/edit/:appraisalId"}
              Component={DebtLiabilityAppraisalFormEdit}
            />
            <Route
              path={"/main/debt-liability/view/:appraisalId"}
              Component={DebtLiabilityAppraisalFormView}
            />
            <Route
              path={"/userrolemap/list"}
              element={userContext.isAdmin ? <UserRoleMapDashboard/>:<>Unauthorized</>}
            />
            <Route
              path="/userrolemap/:page/:userRoleId"
              element={userContext.isAdmin ? <UserRoleMapEditDisplayForm />:<>Unauthorized</>}
            />
            <Route path={"/settings/appraisal-firm/:formtype/:appraiserId"} element={userContext.isAdmin ? <Firm/>:<>Unauthorized</>} />
            <Route path={"/settings/appraisal-firm/new"} element={userContext.isAdmin ? <AppraiserFirmNewForm/>:<>Unauthorized</>} />
            <Route path={"/settings/appraisal-firm/list"} element={userContext.isAdmin ? <AppraiserFirmDashboard/>:<>Unauthorized</>} />
            <Route path="/userrolemap/:page" element={userContext.isAdmin ? <UserRoleMapFormNew />:<>Unauthorized</>} />
            <Route
              path={"/fundconfig/list"}
              element={userContext.isAdmin ? <FundConfigurationDashboard/>:<>Unauthorized</>}
            />
            <Route
              path="/fundconfig/:page/:fundID"
              element={userContext.isAdmin ? <FundConfigurationDisplayEditForm />:<>Unauthorized</>}
            />
            <Route
              path="/fundconfig/:page"
              element={userContext.isAdmin ? <FundConfigurationNewForm />:<>Unauthorized</>}
            />
            <Route
              path={"/appraiserfirm/list"}
              element={userContext.isAdmin ? <AppraiserFirmDashboard/>:<>Unauthorized</>}
            />
            <Route
              path="/appraiserfirm/:page/:id"
              element={userContext.isAdmin ? <Firm />:<>Unauthorized</>}

            />

            <Route
              path="/appraiserfirm/:page"
              element={userContext.isAdmin ? <AppraiserFirmNewForm />:<>Unauthorized</>}
            />
            <Route path="/userrolemap/:page" element={userContext.isAdmin ? <UserRoleMapFormNew />:<>Unauthorized</>} />
            <Route
              path={"/investmentmaster/list"}
              element={userContext.isAdmin ? <InvestmentsDashboard/>:<>Unauthorized</>}
            />
            <Route
              path="/investmentmaster/:page/:investmentId"
              element={userContext.isAdmin ? <InvestmentEditDisplayForm />:<>Unauthorized</>}
            />
            <Route
              path="/investmentmaster/:page"
              element={userContext.isAdmin ? <InvetmentsFormNew />:<>Unauthorized</>}
            />
            <Route path={"/funds/list"} element={userContext.isAdmin ? <FundsDashboard/> :<>Unauthorized</>} />
            <Route path="/funds/:page/:fundID" element={userContext.isAdmin ? < FundDisplayEditForm /> :<>Unauthorized</>} />
            <Route path="/funds/:page" element={userContext.isAdmin ? <FundNewForm />:<>Unauthorized</>} />
            <Route path={"/todo/list"} element={userContext.isAdmin ? <TodoDashboard />: <>Unauthorized</>} />
            <Route path={"/role/list"} element={userContext.isAdmin ? <RoleDashboard/>:<>Unauthorized</>} />
            <Route path="/role/:page/:fundID" element={userContext.isAdmin ? <RoleEditDisplayForm /> :<>Unauthorized</>} />
            <Route path="/role/:page" element={userContext.isAdmin ? <RoleEditDisplayForm />:<>Unauthorized</>} />
            <Route
              path={"/global/global-equity/edit/:appraisalId"}
              Component={GlobalAppraisalEditDisplayForm}
            />
            <Route
              path={"/global/global-equity/view/:appraisalId"}
              Component={GlobalAppraisalEditDisplayForm}
            />

            <Route path="*" element={
              <RootComponent user={userContext}/>
              } />
            <Route path="/unauthorized" element={<Unauthorized />} />
          </Routes >
        </Container >
        <Footer />
      </Router >
    </div >
  );
};

const App = () => {
  function ErrorComponent(error: any) {
    return <p>An Error Occurred: {error}</p>;
  }

  function LoadingComponent() {
    return <p>Authentication in progress...</p>;
  }
  return (
    <AuthProvider>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        errorComponent={ErrorComponent}
        loadingComponent={LoadingComponent}
      >
        {/* <p>This will only render if a user is signed-in.</p> */}
        <Main />
      </MsalAuthenticationTemplate>
    </AuthProvider>
  );
};

export default App;
